import React, { FunctionComponent } from 'react';
import styles from './article-paragraph.module.scss';

export interface IArticleParagraphProps {
  number: string;
  content: string;
  title: string;
  removeMarginTop: boolean;
}

export const ArticleParagraph: FunctionComponent<IArticleParagraphProps> = ({
  number,
  content,
  title,
  removeMarginTop
}) => {
  return (
    <div className={styles.wrapper}>
      {(title || number) && (
        <div
          className={`${styles.header} ${removeMarginTop &&
            styles.removeMarginTop}`}
        >
          <div className={styles.number}>{number}</div>
          <h3 className={styles.title}>{title}</h3>
        </div>
      )}
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
    </div>
  );
};
